import type { ProductCard } from "@/lib/centra/formatters/formatProductCards/formatProductCard";

const formatProductsForPlp = (
  products: ProductCard[] | undefined,
  count: number
) => {
  // divide into arrays of 8
  const formattedProducts: {
    products: ProductCard[];
  }[] = [];
  if (!products) return formattedProducts;
  for (let i = 0; i < products.length; i += count) {
    formattedProducts.push({
      products: products.slice(i, i + count)
    });
  }
  return formattedProducts;
};
export default formatProductsForPlp;
